/* Email-capture popup — minimal show/hide gating.

   Rule (kept intentionally dumb):
     - Visitor sees the popup AT MOST ONCE per browser, forever.
     - On dismiss OR on submit, set localStorage `lt-email-popup-shown=1`.
     - If the flag is set on any subsequent page load, do nothing.
     - The only path that bypasses the flag is the post-submit "success state"
       render — Shopify reloads the page with the discount code visible, and
       we must keep it visible long enough for the visitor to copy the code.

   Hard skips (never show, regardless of flag):
     - Logged-in customer (data-logged-in="1")
     - Conversion-critical pages: /cart, /checkout/*, /pages/wishlist
     - October spin wheel owns email capture: [data-spin-wheel-active] is on
       the wheel root (set by spin-wheel.js, which runs first), or this browser
       already claimed a wheel prize (localStorage lt-spin-wheel-claimed=1).
       Checked before anything is bound, so even the post-submit WELCOME5
       success state stays hidden while the wheel is live.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'lt-email-popup-shown';
  var SUPPRESSED_PATHS = ['/cart', '/checkout', '/pages/wishlist'];

  function wasShown() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; }
    catch (e) { return false; }
  }

  function markShown() {
    try { localStorage.setItem(STORAGE_KEY, '1'); }
    catch (e) { /* private mode / quota — ignore */ }
  }

  function pathSuppressed() {
    var p = window.location.pathname;
    for (var i = 0; i < SUPPRESSED_PATHS.length; i++) {
      if (p === SUPPRESSED_PATHS[i] || p.indexOf(SUPPRESSED_PATHS[i] + '/') === 0) {
        return true;
      }
    }
    return false;
  }

  function spinWheelOwnsCapture() {
    if (document.querySelector('[data-spin-wheel-active]')) return true;
    try { return localStorage.getItem('lt-spin-wheel-claimed') === '1'; }
    catch (e) { return false; }
  }

  function open(root, force) {
    if (root.classList.contains('is-open')) return;
    if (!force && wasShown()) return;
    root.hidden = false;
    /* Force a frame so the transition runs from the hidden state. */
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';

    var input = root.querySelector('.email-popup__input');
    if (input) {
      setTimeout(function () { try { input.focus(); } catch (e) {} }, 250);
    }
  }

  function close(root) {
    root.classList.remove('is-open');
    setTimeout(function () { root.hidden = true; }, 240);
    document.body.style.overflow = '';
    markShown();
  }

  function bindClose(root) {
    root.querySelectorAll('[data-email-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () { close(root); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        close(root);
      }
    });
  }

  function bindForm(root) {
    var form = root.querySelector('form.email-popup__form');
    if (!form) return;
    form.addEventListener('submit', function () {
      /* Mark shown optimistically — even if the server rejects, we don't
         want to re-show. */
      markShown();
    });

    /* If the form was rendered post-submit with the success state, force
       the popup open so the visitor can copy the discount code.
       Bypasses the flag (force=true). */
    if (root.querySelector('[data-email-popup-success]')) {
      open(root, true);
    }
  }

  function bindCopy(root) {
    var btn = root.querySelector('[data-popup-code-copy]');
    var codeEl = root.querySelector('[data-popup-code]');
    if (!btn || !codeEl) return;
    var original = btn.textContent;
    btn.addEventListener('click', function () {
      var code = (codeEl.textContent || '').trim();
      if (!code) return;
      var done = function () {
        btn.textContent = 'Copied!';
        btn.classList.add('is-copied');
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-copied');
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {
          fallbackCopy(code); done();
        });
      } else {
        fallbackCopy(code); done();
      }
    });
  }

  function fallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) { /* nothing more to do */ }
  }

  function init() {
    var root = document.querySelector('[data-email-popup]');
    if (!root) return;
    if (spinWheelOwnsCapture()) return;

    var loggedIn = root.getAttribute('data-logged-in') === '1';
    var delayMs = parseInt(root.getAttribute('data-delay-ms'), 10) || 20000;

    bindClose(root);
    bindForm(root);
    bindCopy(root);

    if (loggedIn) return;
    if (pathSuppressed()) return;
    if (wasShown()) return;

    setTimeout(function () { open(root); }, delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
